import { ReduxUserAccount } from 'common/types';

export const loginSuccessMapper = (payload?: ReduxUserAccount | null) => ({
  loggedIn: true,
  loginError: false,
  loading: false,
  passiveLoginDone: true,
  account: payload ? { ...payload } : null
});
